// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  band: __t.string(),
  envmapAssetId: __t.u64(),
  sunColorHex: __t.string(),
  sunIntensity: __t.f32(),
  sunElevationDeg: __t.f32(),
  ambientIntensity: __t.f32(),
};
